"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeExpressionModel = /** @class */ (function () {
    function MeExpressionModel(id, expression, context, template, type) {
        if (id === void 0) { id = null; }
        if (expression === void 0) { expression = ''; }
        if (context === void 0) { context = []; }
        if (type === void 0) { type = 'NUMERIC'; }
        this.id = id;
        this.expression = expression;
        this.context = context;
        this.template = template;
        this.type = type;
        this.valid = true;
    }
    MeExpressionModel.prototype.clone = function () {
        return new MeExpressionModel(this.id, this.expression, this.context.map(function (context) {
            return {
                id: context.id,
                keys: (context.keys || []).slice(0),
                itemId: context.itemId,
                typeId: context.typeId,
                name: context.name,
                format: context.format,
                filter: context.filter
            };
        }), this.template, this.type);
    };
    return MeExpressionModel;
}());
exports.MeExpressionModel = MeExpressionModel;
var MeExpressionContextModel = /** @class */ (function () {
    function MeExpressionContextModel() {
    }
    return MeExpressionContextModel;
}());
exports.MeExpressionContextModel = MeExpressionContextModel;
//# sourceMappingURL=expression.model.js.map